import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import LivingRoomConsole, { DELETE_FILES_CONFIRM_MESSAGE } from '../components/LivingRoomConsole';
import LivingRoomDocumentUploadModal from '../components/LivingRoomDocumentUploadModal';
import LivingRoomQrModal from '../components/LivingRoomQrModal';
import { promptAppInstall } from '../lib/pwaInstall';
import { SCREENS } from '../lib/screenRegistry';

const PRIVATE_WELCOME =
  "Welcome to the Briefing Room, [Mentee Name]. I am your AI Mentor Jill, and this is your private, high-focus business development space. There is no passive listening here — I will mirror your logic, challenge your assumptions, and hold you accountable to your own insights. Tell me: what is the primary challenge or breakthrough you bring to today's session, and what do you want to achieve from this mentoring relationship?";

const SUBSCRIPTION_ID = 'ELT-ORG-DEV-9842';
const SUBSCRIPTION_DAYS_LEFT = 28;

export default function PrivateMenteeLounge() {
  const navigate = useNavigate();
  const [qrOpen, setQrOpen] = useState(false);
  const [documentUploadOpen, setDocumentUploadOpen] = useState(false);

  const handleCreateAppIcon = async (closeMenu: () => void) => {
    closeMenu();
    await promptAppInstall();
  };

  const handleCancelAndDelete = async (closeMenu: () => void) => {
    closeMenu();
    if (!window.confirm(DELETE_FILES_CONFIRM_MESSAGE)) return;
    const result = await authApi.deleteData();
    if (!result.success) alert(result.message || result.reason);
    else alert('Subscription cancellation and file deletion initiated.');
  };

  return (
    <LivingRoomConsole
      screenId={SCREENS.PRO08}
      welcomeScript={PRIVATE_WELCOME}
      menuContent={(closeMenu) => (
        <>
          <p className="living-room-util-item living-room-util-static">
            Subscription: {SUBSCRIPTION_ID}
          </p>
          <p className="living-room-util-item living-room-util-static">
            Subscription days left: {SUBSCRIPTION_DAYS_LEFT}
          </p>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              navigate('/pro-setup');
            }}
          >
            Change my AI-Mentor Voice
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              setDocumentUploadOpen(true);
            }}
          >
            Upload Business/Industry &amp; General Documents
          </button>
          <button type="button" className="living-room-util-item" onClick={closeMenu}>
            Socratic Reflection History
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              setQrOpen(true);
            }}
          >
            Click for QR code to launch a desktop/homepage AI APP icon
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => handleCreateAppIcon(closeMenu)}
          >
            Create a desktop/homepage AI APP icon
          </button>
          <button type="button" className="living-room-util-item" onClick={closeMenu}>
            Renew subscription
          </button>
          <a
            className="living-room-util-item"
            href="mailto:support@mentology.com.au"
            onClick={closeMenu}
          >
            Contact technical support
          </a>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => handleCancelAndDelete(closeMenu)}
          >
            Cancel subscription and Delete All MY FILES
          </button>
        </>
      )}
      qrModal={qrOpen ? (
        <LivingRoomQrModal
          titleId="private-lounge-qr-title"
          onClose={() => setQrOpen(false)}
        />
      ) : null}
      documentUploadModal={documentUploadOpen ? (
        <LivingRoomDocumentUploadModal
          titleId="private-lounge-doc-upload-title"
          menteeToken={SUBSCRIPTION_ID}
          onClose={() => setDocumentUploadOpen(false)}
        />
      ) : null}
    />
  );
}
